import 'reflect-metadata'
import type { SSRState } from '../../../types'
import {
  registerPerRequestService,
  registerPerRequestServiceToConstantValue,
} from '../../../Foundation/DependencyInjection/container'
import { Container } from 'inversify'
import {
  registerBinding as registerBindingTest,
  SERVICES as SERVICES_TEST,
} from '../../../Feature/Test/DI/serviceRegistration'

import { registerBinding as registerBindingLotApi } from '../../../Foundation/LotApi/serviceRegistration'
import { registerBinding as registerBindingWebView } from '../../../Foundation/WebView/serviceRegistration'
import { registerBinding as registerBindingBase } from '../../../Foundation/Base/serviceRegistration'
import { registerBinding as registerBindingLists } from '../../../Foundation/Lists/serviceRegistration'
import { registerBinding as registerBindingSettings } from '../../../Foundation/Settings/serviceRegistration'
import { registerBinding as registerBindingUtils } from '../../../Foundation/Utils/Caching/serviceRegistration'
import { registerBinding as registerBindingGeolocation } from '../../../Foundation/Geolocation/serviceRegistration'
import { registerBinding as registerBindingLotPages } from '../../../Feature/LotPages/DI/serviceRegistration'
import { registerBinding as registerBindingDomainHandling } from '../../../Foundation/DomainHandling/serviceRegistration'
import { SERVICES as COMMON_SERVICES } from '../../../Foundation/Base/serviceRegistration'
import { SERVICES as SERVICES_LOT } from '../../../Foundation/LotApi/serviceRegistration'
import { SERVICES as GEOLOCATION_SERVICES } from '../../../Foundation/Geolocation/serviceRegistration'
import { SERVICES as DOMAIN_HANDLING_SERVICES } from '../../../Foundation/DomainHandling/serviceRegistration'

import { PerRequestService } from '../../../Feature/Test/Services/PerRequestService'
import { DefaultPerRequestService } from '../../../Feature/Test/Services/DefaultPerRequestService'
import { AuthService } from '../../../Foundation/WebAuth/AuthService'
import { HttpRequestContext } from '../../../Foundation/Utils/HttpRequestContext'
import { LotService } from '../../../Foundation/LotApi/Services/LotService'
import { LotServiceWithCaching } from '../../../Foundation/LotApi/Services/LotServiceWithCaching'
import { GeoLocationService } from '../../../Foundation/Geolocation/GeoLocationService'
import { DomainService } from '../../../Foundation/DomainHandling/DomainService'

let registered = false
export function registerBinding(container: Container): void {
  if (registered === false) {
    // registering DI for each module
    registerBindingBase(container)
    registerBindingTest(container)
    registerBindingLotApi(container)
    registerBindingWebView(container)
    registerBindingLists(container)
    registerBindingUtils(container)
    registerBindingGeolocation(container)
    registerBindingLotPages(container)
    registerBindingSettings(container)
    registerBindingDomainHandling(container)
    registered = true
  }
}

// registerPerRequestService is a helper method
export function registerPerRequestBinding(container: Container, ssrState: SSRState): void {
  const ssrContext = ssrState?.sitecore?.context

  registerPerRequestServiceToConstantValue<AuthService>(container, COMMON_SERVICES.AuthService, {
    isUserAuthenticated: ssrContext?.isUserAuthenticated ?? false,
  })
  registerPerRequestService<PerRequestService>(container, SERVICES_TEST.PerRequestService, DefaultPerRequestService)

  registerPerRequestServiceToConstantValue<() => LotService>(container, SERVICES_LOT.LotService, () => {
    const lotFetchService = container.get<LotService>(SERVICES_LOT.LotFetchService)
    const geoLocatinService = container.get<GeoLocationService>(GEOLOCATION_SERVICES.GeoLocationService)
    const replaceDomainService = container.get<DomainService>(DOMAIN_HANDLING_SERVICES.ReplaceDomainService)
    return new LotServiceWithCaching(lotFetchService, geoLocatinService, replaceDomainService)
  })

  registerPerRequestServiceToConstantValue<HttpRequestContext>(container, COMMON_SERVICES.HttpRequestContext, {
    language: ssrContext?.language ?? 'en',
    isUserAuthenticated: ssrContext?.isUserAuthenticated ?? false,
    headers: ssrState?.sitecore?.httpHeaders ?? {},
    replaceDomains: {
      inputDomains: ssrContext?.['Discovery.Foundation.DomainHandling.InputDomains'] ?? [],
      outputDomains: ssrContext?.['Discovery.Foundation.DomainHandling.OutputDomains'] ?? [],
      excludedDomains: ssrContext?.['Discovery.Foundation.DomainHandling.ExcludedDomains'] ?? [],
    },
  })
}

//  DON'T DELETE - used by DW
